import { render, staticRenderFns } from "./WalletOption.vue?vue&type=template&id=9a808462&scoped=true&"
import script from "./WalletOption.vue?vue&type=script&lang=js&"
export * from "./WalletOption.vue?vue&type=script&lang=js&"
import style0 from "./WalletOption.vue?vue&type=style&index=0&id=9a808462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a808462",
  null
  
)

export default component.exports